import { styledComponent, Grid, Box, Divider } from '@hermes/web-components'

const borderNone = 'none !important'
const transitionDuration = '0.1s linear'

export const SearchProfileCardContainer = styledComponent(Box, {
  shouldForwardProp: (prop: string) => !['topBorder'].includes(prop)
})<{
  topBorder?: boolean
}>(({ theme, topBorder }) => ({
  display: 'flex',
  gap: '16px',
  flexDirection: 'row',
  width: '100%',
  border: `1px solid ${theme.palette.blue['200']}`,
  borderRadius: '16px',
  transition: transitionDuration,
  cursor: 'pointer',
  '&:hover': {
    border: `1px solid ${theme.palette.blue['400']}`,
    hr: {
      backgroundColor: theme.palette.blue['400']
    },
    '.rate-paper-container': {
      borderColor: theme.palette.blue['400']
    }
  },
  [theme.breakpoints.down('lg')]: {
    gap: 0,
    flexDirection: 'column',
    maxHeight: '100%',
    borderRadius: 0,
    ...(topBorder
      ? {
          borderLeft: borderNone,
          borderRight: borderNone,
          borderBottom: borderNone,
          borderTop: `1px solid ${theme.palette.grey['100']} !important`
        }
      : {
          border: 'none !important'
        })
  }
}))

export const ProfileTitleContainer = styledComponent(Grid)(({ theme }) => ({
  flexDirection: 'column',
  gap: '12px',
  justifyContent: 'center',
  [theme.breakpoints.down('lg')]: {
    justifyContent: 'flex-start'
  }
}))

export const StyledDivider = styledComponent(Divider)(({ theme }) => ({
  border: 'none',
  transition: transitionDuration,
  backgroundColor: theme.palette.blue[200],
  height: '1px',
  minWidth: '100%'
}))

export const RatePaperContainer = styledComponent(Grid)(({ theme }) => ({
  gap: '16px',
  flexBasis: '45%',
  alignItems: 'center',
  padding: '16px',
  alignContent: 'center',
  transition: transitionDuration,
  [theme.breakpoints.up('lg')]: {
    borderLeft: `1px solid ${theme.palette.blue[200]}`
  },
  [theme.breakpoints.down('lg')]: {
    gap: '12px',
    flexBasis: '100%'
  }
}))

export const ContactContainer = styledComponent(Grid)(({ theme }) => ({
  gap: '16px',
  [theme.breakpoints.down('lg')]: {
    marginTop: '4px'
  }
}))
